<template>
  <v-app id="inspire">
    <v-content>
      <router-view />
    </v-content>
    <loading />
    <snackbar />
  </v-app>
</template>
<script>
import loading from "./components/Loading";
import snackbar from "./components/snackbar";
import axios from "axios";
import store from "./store";
import router from "./router";
import api from "./conf/ruta-base";
export default {
  name: "App",
  components: {
    loading,
    snackbar,
  },
  created() {
    axios.interceptors.request.use(
      function (config) {
        store.commit("loading", true);
        const auth_token = sessionStorage.getItem("token");
        if (auth_token) {
          config.headers = { Authorization: "Bearer " + auth_token };
        }
        return config;
      },
      function (error) {
        store.commit("loading", false);
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        store.commit("loading", false);
        return response;
      },
      function (error) {
        const originalRequest = error.config;
        if (error.response.status === 404) {
          sessionStorage.removeItem("token");
          store.commit("loading", false);
          router.push("login");
          return Promise.reject(error);
        }
        if (
          (error.response.status === 401 || error.response.status === 404) &&
          originalRequest.url ===
            api.api + "renewtoken/" + sessionStorage.getItem("userId")
        ) {
          sessionStorage.removeItem("token");
          store.commit("loading", false);
          router.push("login");
          return Promise.reject(error);
        }
        if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          const usr = sessionStorage.getItem("userId");
          if (!usr) return Promise.reject(error);
          return axios
            .post(api.api + "renewtoken/" + sessionStorage.getItem("userId"))
            .then((res) => {
              if (res.status === 200) {
                sessionStorage.token = res.data.token;
                axios.defaults.headers = {
                  Authorization: "Bearer " + res.data.token,
                };
                return axios(originalRequest);
              } else {
                store.commit("loading", false);
                router.push("login");
              }
            })
            .catch((err) => {
              store.commit("loading", false);
              router.push("login");
            });
        }
        store.commit("loading", false);
        return Promise.reject(error);
      }
    );
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.v-stepper__label {
  font-size: 11px !important;
  text-align: center !important;
}
</style>
